/* eslint-disable import/prefer-default-export */

export enum ETaskType {
  Installation = "installation",
  Test = "test",
  WORK = "Work",
}
